import type { Components, Theme } from "@mui/material";

import { defaultFontFamily } from "../fontFamily.ts";

export const listItemButtonTheme: Components<Theme>["MuiListItemButton"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: defaultFontFamily,
      "& .MuiTypography-root": {
        fontFamily: defaultFontFamily,
      },
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      borderRadius: theme.spacing(1),
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    }),
  },
};
